import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "download" }
const _hoisted_2 = { class: "jumbotron" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "display-4" }, "Download", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Click on the link to download", -1)
const _hoisted_6 = ["href"]
const _hoisted_7 = { key: 1 }

import { onMounted, computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { Booking } from "@/models";

// Replace class property with a reactive reference

export default /*#__PURE__*/_defineComponent({
  __name: 'Download',
  setup(__props) {

const booking = ref(new Booking());

// Use the store
const store = useStore();
const route = useRoute();

// Convert getBooking action
const getBooking = (id: string): Promise<Booking> => {
  return store.dispatch('diary/getBooking', id);
};

// Mounted lifecycle hook
onMounted(async () => {
  getBooking(route.params.id as string)
  .then((b: Booking) => booking.value = b);
});

// Convert computed property
const documents = computed(() => {
  return booking.value?.dataentrydocuments ?? [];
});

// Convert method
const getFilename = (src: string) => {
  let filename = '';
  if (src) {
    const lastindex = src.lastIndexOf("/");
    if (lastindex >= 0) {
      filename = src.substring(lastindex + 1);
    }
  }
  return filename;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (documents.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(documents.value, (document, $index) => {
                return (_openBlock(), _createElementBlock("li", { key: $index }, [
                  _createElementVNode("a", {
                    href: document.src
                  }, _toDisplayString(getFilename(document.src)), 9, _hoisted_6)
                ]))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, "There are currently no documents with this job!"))
    ])
  ]))
}
}

})